import { Card, CardHeader, CardContent } from "@material-ui/core";
import { CompanyClickAccessKpi } from "./CompanyClickAccessKpi";
import { OfficeDaysVisit } from "./OfficeDaysVisitKpi";
import { OfficeMonthVisit } from "./OfficeMonthVisitKpi";

export const UsersKpi = () => {
  return (
    <Card>
      <CardHeader title="Users KPI" />
      <CardContent>
        <CompanyClickAccessKpi></CompanyClickAccessKpi>
        {/* one of the user visit kpi component can be reused */}
        <OfficeDaysVisit></OfficeDaysVisit>
        <OfficeMonthVisit></OfficeMonthVisit>
      </CardContent>
    </Card>
  );
};
